


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, RiskTextForScore } from "@/model/Model";
import DrinkDrivingAdvice from "./DrinkDrivingAdvice.vue";
import RiskStats from "./RiskStats.vue";
import PregnancyAdvice from "./PregnancyAdvice.vue";
import RisksAnalysisBlurb from "./RisksAnalysisBlurb.vue";
import RisksAnalysisIcons from "./RisksAnalysisIcons.vue";
import { Borough } from "@/model/Boroughs";
import { RiskLevel } from "@/model/RiskLevel";

@Component({
  components: {
    RisksAnalysisBlurb,
    RisksAnalysisIcons,
    PregnancyAdvice,
    DrinkDrivingAdvice,
    RiskStats
  }
})
export default class RisksAnalysis extends Vue {
  public static navButtonClasses: string[] = ["what-are-the-risks"];
  public static navButtonLabel: () => string = () => "What are the risks?";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }

  private get isLowerRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Lower;
  }

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private get isHigherRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get riskName(): string {
    return RiskTextForScore(this.score);
  }

  private get isMale(): boolean {
    return this.gender === Gender.Male;
  }

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }
}
